let closeLabelObserver;

document.addEventListener('click', async (event) => {
  const link = event.target.closest?.('.footer__cookie-settings');
  const banner = typeof privacyBanner !== 'undefined' ? privacyBanner : window.privacyBanner;
  if (!link || !banner?.showPreferences) return;

  event.preventDefault();
  const labelClose = () => {
    const close = document.getElementById('shopify-pc__prefs__header-close');
    const label = link.dataset.cookieCloseLabel;
    if (close && label && close.getAttribute('aria-label') !== label) {
      close.setAttribute('aria-label', label);
    }
  };
  closeLabelObserver?.disconnect();
  closeLabelObserver = new MutationObserver(labelClose);
  closeLabelObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label'],
  });
  try {
    await banner.showPreferences({
      locale: link.dataset.cookieLocale,
      country: link.dataset.cookieCountry,
    });
    labelClose();
  } catch {
    closeLabelObserver.disconnect();
    window.location.hash = 'shopifyReshowConsentBanner';
  }
});
